import React from "react";

export default function Hero({ t }) {
  return (
    <section className="hero-section">
      {/* 背景视频 */}
      <video
        autoPlay
        muted
        loop
        playsInline
        className="hero-video"
      >
        <source src="/herovideo.mp4" type="video/mp4" />
      </video>

      {/* 暗层提高可读性 */}
      <div className="hero-overlay" />

      {/* 内容层 */}
      <div className="hero-content">
        <h1 className="hero-title">{t.title}</h1>
        <p className="hero-subtitle">{t.subtitle}</p>
      </div>
    </section>
  );
}
